import { CSSProperties } from "react";

const ACCENT_SECTION_STYLE: CSSProperties = {
  background: "var(--cream-ink)",
  borderTop: "1px solid var(--grey-200)",
  borderBottom: "1px solid var(--grey-200)",
};

export default ACCENT_SECTION_STYLE;
